import { useEffect, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { Breadcrumbs, Typography, Box, Stack } from '@mui/material';

import { MainContainer } from '../../../../components/MainContainer/MainContainer';
import { Container } from '../../../../components/Container/Container';
import { Menu } from '../Menu/Menu';
import RadiusButton from '../../../../components/RadiusButton';
import { listByConfigurationId, verifyQuestionsByConfigurationId } from '../../../../services/questionService';

import ARROW from '../../../../assets/images/breadcrumb-arrow.svg';
import ARROW_OPEN from '../../../../assets/images/breadcrumb-arrow-open.svg';
import ARROW_LEFT from '../../../../assets/images/back.svg';

import './DescriptiveContentPreview.scss';

export const DescriptiveContentPreview = () => {

    const params = useParams();
    const projectName = params?.projectName;
    const location = useLocation();
    const navigate = useNavigate();
    const [drive, setDrive] = useState(null);
    const [course, setCourse] = useState(null);
    const [language, setLanguage] = useState('');
    const [setNumber, setSetNumber] = useState(null);
    const [configurationId, setConfigurationId] = useState(null);
    const [questions, setQuestions] = useState([]);

    useEffect(() => {
        const configurationId = location?.state?.configurationId;
        const language = location?.state?.language;
        const setNumber = location?.state?.setNumber;
        const drive = location?.state?.drive;
        const course = location?.state?.course;
        if (!configurationId || !language || !setNumber || !drive || !course) {
            navigate(`/${projectName}/upload/content`, {
                state: {
                    configurationId: configurationId,
                    drive: drive,
                    course: course,
                }
            })
        }

        const fetchData = async () => {
            try {
                const res = await listByConfigurationId({
                    configurationId: configurationId,
                    imageSize: 'L',
                    language: language,
                    set: setNumber,
                });
                if (res.code === 'OK') {
                    const questions = res.data.list ?? [];
                    setQuestions(
                        questions.sort((q1, q2) => q1.questionNo - q2.questionNo)
                    );
                    setDrive(drive);
                    setCourse(course);
                    setLanguage(language);
                    setSetNumber(setNumber);
                    setConfigurationId(configurationId);
                }
            } catch (error) {
                console.log('There is an error while getting descriptive questions', error);
            }
        }
        fetchData();
    }, [location]);

    const onGoBack = () => {
        if (projectName) {
            navigate(`/${projectName}/upload`, {
                state: {
                    activeTab: 'content',
                    configurationId: configurationId,
                    drive: drive,
                    course: course,
                }
            });
        }
    }

    const handleFinish = async () => {
        if (!questions[0]?.isVerified) {
            try {
                const res = await verifyQuestionsByConfigurationId({
                    configurationId: configurationId,
                    language: language,
                    set: setNumber
                });
                if (res.code === 'OK') {
                    onGoBack();
                }
            } catch (error) {
                console.log('There is an error while verifing question', error);
            }
        } else {
            onGoBack();
        }
    }

    return (
        <MainContainer >
            <Menu>
                <Breadcrumbs aria-label="breadcrumb" separator='' sx={{ gap: 12 }}>
                    <Typography color="text.primary" sx={{ fontWeight: 400 }}>Dashboard</Typography>
                    <Box sx={{ display: 'flex', alignContent: 'center' }}>
                        <img src={ARROW} alt=''></img>
                    </Box>

                    <Typography color="text.primary" sx={{ fontWeight: 500 }}>Content Preview</Typography>
                    <Box sx={{ display: 'flex', alignContent: 'center' }}>
                        <img src={ARROW_OPEN} alt='' ></img>
                    </Box>
                </Breadcrumbs>
            </Menu>

            <Container sx={{ display: 'flex', flexDirection: 'column' }}>
                <Typography variant='h5' component='h5' sx={{ mb: 2 }}>Content Preview</Typography>
                <Box sx={{
                    display: 'flex',
                    alignItems: 'center',
                    mb: 2,
                }}>
                    <Typography variant='h6' component='h6' sx={{ textTransform: 'capitalize' }}>{course?.name}</Typography>
                    <Typography variant='h6' component='h6' sx={{ textTransform: 'capitalize', ml: 'auto' }}>Set - {setNumber}</Typography>
                    <Typography variant='h6' component='h6' sx={{ textTransform: 'capitalize', ml: 2 }}>Language - {language}</Typography>
                </Box>
                <Box sx={{
                    flex: 1,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'flex-start',
                    backgroundColor: 'background.base',
                    borderRadius: 4,
                    maxWidth: 'calc(100vw - 135px)',
                    mb: 1.5,
                    px: 1,
                    py: 1.5,
                    overflow: 'auto'
                }}>
                    <Box sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'flex-start'
                    }}>
                    </Box>
                    {questions.map((q, index) => {
                        return <img key={index} src={q.question} alt='' />
                    })}
                </Box>

                <Box sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'flex-end',
                    flexWrap: 'wrap',
                    gap: 1,
                }}>
                    <Stack sx={{ display: 'flex', justifyContent: 'right' }} direction="row" spacing={2}>
                        <RadiusButton sx={{
                            fontWeight: 500,
                            textTransform: 'uppercase'
                        }} variant='contained' color='grey' startIcon={<img src={ARROW_LEFT} alt='' />}
                            size='large' onClick={onGoBack}>
                            Back
                        </RadiusButton>
                        <RadiusButton color="primary"
                            variant='contained'
                            size='large'
                            sx={{
                                fontWeight: 500,
                            }}
                            onClick={handleFinish}
                        >{questions[0]?.isVerified ? 'FINISH' : 'VERIFY'}</RadiusButton>
                    </Stack>
                </Box>

            </Container>
        </MainContainer>
    );
}
